import React, { useEffect, useState } from "react";
import {
  getAllPlazoNotas,
  eliminarPlazoNotas,
  actualizarPlazoNotas
} from "../../services/plazoNotas.service";
import { getAllGrupos } from "../../services/grupo.service";
import { getAllDocentes } from "../../services/docente.service";
import {
  showDeletedAlert,
  showErrorAlert,
  showActualizadoCorrectamenteAlert,
} from "../../components/molecules/ShowAlert";
import { PlazoNotasCard } from "./PlazoNotasCard";

export const PlazoNotasList = () => {
  const [plazos,   setPlazos]   = useState([]);
  const [grupos,   setGrupos]   = useState([]);
  const [docentes, setDocentes] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        const [pls, grs, dcs] = await Promise.all([
          getAllPlazoNotas(),
          getAllGrupos(),
          getAllDocentes(),
        ]);

        const hoy      = new Date();
        const y        = hoy.getFullYear();
        const m        = hoy.getMonth();
        const d        = hoy.getDate();
        const inicio   = new Date(y, m, d, 0, 0, 0, 0).getTime();       
        const fin      = new Date(y, m, d, 23, 59, 59, 999).getTime();  
        const plHoy    = pls.filter((p) => {
          const t = new Date(p.creadoEn).getTime();
          return t >= inicio && t <= fin;
        });

        setPlazos(plHoy);
        setGrupos(grs);
        setDocentes(dcs);
      } catch {
        showErrorAlert({ text: "Error al cargar los plazos." });
      }
    })();
  }, []);

  const handleDelete = async (id) => {
    try {
      await eliminarPlazoNotas(id);
      setPlazos((prev) => prev.filter((p) => p.idPlazoNotas !== id));
      showDeletedAlert();
    } catch {
      showErrorAlert({ text: "No se pudo eliminar el plazo." });
    }
  };

  const handleEdit = (p) => console.log("Editar plazo:", p);
  const handleView = (p) => console.log("Ver detalle estudiantes:", p);

  const buscarDocente = (id) =>
    docentes.find(
      (d) =>
        d.idDocente === id ||            
        d.docente?.idDocente === id     
    );

  return (
    <div className="max-w-2xl mx-auto mt-8 space-y-2">
      <h2 className="text-2xl font-bold mb-4">Plazos Registrados</h2>

      {plazos.length === 0 && (
        <p className="text-gray-600">No hay plazos registrados hoy.</p>
      )}

      {plazos.map((plazo, i) => (
        <PlazoNotasCard
          key={plazo.idPlazoNotas}
          index={i + 1}
          plazo={plazo}
          grupo={grupos.find((g) => g.idGrupo === plazo.idGrupo)}
          docente={buscarDocente(plazo.idDocente)}
          onDelete={handleDelete}
          onEdit={handleEdit}
          onView={handleView}
        />
      ))}
    </div>
  );
};